export const canSeeCarWow = (window, userType, postAdPageType, sellerType, categoryId): boolean => {
    return (
        window.growthbook?.isOn('GTP-3764') &&
        userType === 'STANDARD' &&
        postAdPageType === 'create' &&
        sellerType &&
        sellerType === 'private' &&
        categoryId === 9311
    );
};
